export interface Document {
  id?: number;
  fermeId: number;
  dossierId?: number | null;
  nom: string;
  /** FACTURE | PROFORMA | AVOIR | RECU | JUSTIFICATIF | CONTRAT | CERTIFICAT | TITRE_FONCIER | SUBVENTION
   *  | IDENTITE | RAPPORT | PHOTO | AUTRE */
  type: string;
  /** Ancien stockage (Firebase) : vide pour les fichiers stockés par l'API */
  fileUrl?: string;
  tailleFichier?: number;
  mimeType?: string;
  createdAt?: string;
  /** Enrichi côté service */
  dossierNom?: string;

  description?: string;
  tags?: string[];
  dateDocument?: string;
  lienType?: string;
  lienId?: number;
  lienLabel?: string;
  /** UPLOAD | PHOTO | GENERE */
  origine?: string;
  dateExpiration?: string;
  createdBy?: string;
  /** ACTIF | CORBEILLE */
  statut?: string;
  supprimeLe?: string;
  fichierDisponible?: boolean;
  miniatureDisponible?: boolean;
  partagePublic?: boolean;
}

/** Types de documents, libellés, icônes et couleurs (une seule source pour tous les écrans) */
export const TYPES_DOCUMENT: { value: string; label: string; icon: string; color: string }[] = [
  { value: 'FACTURE', label: 'Facture', icon: 'receipt_long', color: '#1d4ed8' },
  { value: 'PROFORMA', label: 'Proforma', icon: 'request_quote', color: '#92400e' },
  { value: 'AVOIR', label: 'Avoir', icon: 'undo', color: '#6b7280' },
  { value: 'RECU', label: 'Reçu', icon: 'receipt', color: '#0d631b' },
  { value: 'JUSTIFICATIF', label: 'Justificatif', icon: 'payments', color: '#b91c1c' },
  { value: 'CONTRAT', label: 'Contrat', icon: 'handshake', color: '#7c3aed' },
  { value: 'CERTIFICAT', label: 'Certificat', icon: 'verified', color: '#0369a1' },
  { value: 'TITRE_FONCIER', label: 'Titre foncier', icon: 'landscape', color: '#795548' },
  { value: 'SUBVENTION', label: 'Subvention', icon: 'volunteer_activism', color: '#0f766e' },
  { value: 'IDENTITE', label: 'Pièce d\'identité', icon: 'badge', color: '#475569' },
  { value: 'RAPPORT', label: 'Rapport', icon: 'summarize', color: '#0d631b' },
  { value: 'PHOTO', label: 'Photo', icon: 'photo_camera', color: '#a16207' },
  { value: 'AUTRE', label: 'Autre', icon: 'description', color: '#6b7280' },
];

export function typeDocument(type: string) {
  const t = type === 'DEPENSE' ? 'JUSTIFICATIF' : type;
  return TYPES_DOCUMENT.find(x => x.value === t) || TYPES_DOCUMENT[TYPES_DOCUMENT.length - 1];
}

/** Objets métier auxquels un document peut être relié */
export const LIENS_DOCUMENT: { [type: string]: { label: string; icon: string; route?: (id: number) => any[] } } = {
  FACTURE: { label: 'Facture', icon: 'receipt_long', route: id => ['/factures/details', id] },
  REVENU: { label: 'Revenu', icon: 'trending_up', route: id => ['/finances'] },
  DEPENSE: { label: 'Dépense', icon: 'trending_down', route: id => ['/finances'] },
  PAIEMENT: { label: 'Paiement', icon: 'paid' },
  CONTACT: { label: 'Contact', icon: 'person', route: id => ['/contacts-crm', id] },
  TROUPEAU: { label: 'Troupeau', icon: 'pets', route: id => ['/betail/troupeau/details', id] },
  LOT_VOLAILLE: { label: 'Cohorte de volaille', icon: 'egg', route: id => ['/volaille/details', id] },
  PISCICULTURE: { label: 'Cohorte de poissons', icon: 'set_meal', route: id => ['/pisciculture/details', id] },
  CULTURE: { label: 'Culture', icon: 'eco', route: id => ['/maraichage/details', id] },
  EQUIPEMENT: { label: 'Équipement', icon: 'construction', route: id => ['/equipements', id] },
  ARTICLE_STOCK: { label: 'Article de stock', icon: 'inventory_2', route: id => ['/stock', id] },
  RAPPORT: { label: 'Rapport', icon: 'summarize' },
};
